<template>
  <div id="applyIndex" class="apply-index">
    <div class="apply-header">
      <p class="apply">应用</p>
      <span v-if="menu" @click="toUrl" class="apply-title">{{menu}}</span>
      <span v-if="childTitle">/{{childTitle}}</span>
    </div>
    <div class="apply-container">
      <router-view @childMueu="childMueu"></router-view>
    </div>
  </div>
</template>

<script >
export default {
  data() {
    return {
      menu: "",
      childTitle: "",
      url: "",
    };
  },
  methods: {
    childMueu(data, childTitle ,url) {
      this.menu = data;
      this.childTitle = childTitle;
      this.url = url;
    },
    toUrl() {
      this.$router.push({
        path: this.url
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.apply-index {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
  .apply-header {
    height: 40px;
    background: #ebedf1;
    width: 100%;
    font-size: 16px;
    box-sizing: border-box;
    padding-left: 44px;
    line-height: 40px;
    display: flex;
    align-items: center;
    .apply {
      margin-right: 64px;
      font-weight: bold;
    }
  }
  .apply-title {
    cursor: pointer;
  }
  .apply-container {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }
}
</style>
